/**
 * ISSUE #47 FIX 3.47.5: LessonPlayer Styles
 * Extracted styles for the audio player component
 */

export const styles = {
  playerContainer: {
    width: "100%",
    maxWidth: "100%",
    marginBottom: 0,
    boxSizing: "border-box",
  },
  videoStylePlayerContainer: {
    backgroundColor: "#1a1d23",
    borderRadius: "12px",
    overflow: "hidden",
    boxShadow: "0 4px 24px rgba(0,0,0,0.12)",
    border: "1px solid rgba(255,255,255,0.08)",
    display: "flex",
    flexDirection: "column",
    width: "100%",
    maxWidth: "100%",
    boxSizing: "border-box",
  },
  playerVisualArea: {
    backgroundImage: "linear-gradient(145deg, #434343 0%, #1a1a2e 50%, #16213e 100%)",
    aspectRatio: "16 / 9",
    maxHeight: "min(52vh, 420px)",
    minHeight: "160px",
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    overflow: "hidden",
    boxSizing: "border-box",
  },
  audioInfoOverlay: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    height: "100%",
    color: "white",
    position: "relative",
    padding: "16px 20px",
    textAlign: "center",
    boxSizing: "border-box",
  },
  audioNameDisplay: {
    fontSize: "clamp(0.95rem, 2.5vw, 1.35rem)",
    fontWeight: "600",
    marginBottom: "12px",
    maxWidth: "90%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    zIndex: 1,
  },
  audioIconTopRight: {
    fontSize: "clamp(3rem, 12vw, 5rem)",
    opacity: 0.2,
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    pointerEvents: "none",
  },
  playerControlsOverlay: {
    backgroundColor: "#f8f9fa",
    padding: "16px 18px",
    borderTop: "1px solid #e9ecef",
    width: "100%",
    boxSizing: "border-box",
  },
  progressContainer: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    marginBottom: "14px",
    width: "100%",
    minWidth: 0,
  },
  timeDisplay: {
    fontSize: "11px",
    color: "#495057",
    fontWeight: "600",
    minWidth: "38px",
    flexShrink: 0,
    textAlign: "center",
    fontVariantNumeric: "tabular-nums",
  },
  progressBar: {
    flex: 1,
    minWidth: 0,
    height: "8px",
    backgroundColor: "#dee2e6",
    borderRadius: "4px",
    position: "relative",
    cursor: "pointer",
  },
  progressFill: {
    height: "100%",
    backgroundColor: "#007bff",
    borderRadius: "3px",
    transition: "width 0.1s linear",
  },
  progressThumb: {
    width: "14px",
    height: "14px",
    backgroundColor: "#007bff",
    borderRadius: "50%",
    position: "absolute",
    top: "50%",
    transform: "translate(-50%, -50%)",
    boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
  },
  controlsRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "12px",
    flexWrap: "wrap",
    width: "100%",
    minWidth: 0,
  },
  controlsGroup: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    flexWrap: "wrap",
    minWidth: 0,
  },
  controlButton: {
    padding: "8px 12px",
    backgroundColor: "#f0f0f0",
    border: "1px solid #ddd",
    borderRadius: "4px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "14px",
    color: "#333",
    transition: "all 0.2s ease",
  },
  playButton: {
    backgroundColor: "#007bff",
    color: "white",
    border: "1px solid #0056b3",
    fontWeight: "600",
    padding: "10px 20px",
  },
  volumeControl: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  volumeBar: {
    width: "80px",
    height: "4px",
    backgroundColor: "#ddd",
    borderRadius: "2px",
    position: "relative",
    cursor: "pointer",
  },
  volumeFill: {
    height: "100%",
    backgroundColor: "#007bff",
    borderRadius: "2px",
  },
  volumeThumb: {
    width: "10px",
    height: "10px",
    backgroundColor: "#007bff",
    borderRadius: "50%",
    position: "absolute",
    top: "50%",
    transform: "translate(-50%, -50%)",
  },
  playbackRate: {
    position: "relative",
  },
  rateButton: {
    padding: "8px 12px",
    backgroundColor: "#f0f0f0",
    border: "1px solid #ddd",
    borderRadius: "4px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    gap: "6px",
    fontSize: "14px",
    color: "#333",
    transition: "all 0.2s ease",
  },
  rateOptions: {
    position: "absolute",
    top: "100%",
    right: 0,
    backgroundColor: "#fff",
    border: "1px solid #ddd",
    borderRadius: "4px",
    marginTop: "4px",
    zIndex: 100,
    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
  },
  rateOption: {
    padding: "8px 16px",
    cursor: "pointer",
    fontSize: "13px",
    color: "#333",
    borderBottom: "1px solid #f0f0f0",
    transition: "all 0.2s ease",
  },
  activeRate: {
    backgroundColor: "#e3f2fd",
    color: "#007bff",
    fontWeight: "600",
  },
  container: {
    padding: "16px",
    textAlign: "center",
    color: "#666",
  },
};
